import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { InputState } from '../../../util/types';
import { commonVariants } from '../styles.ts';
import React, { forwardRef } from 'react';
import {
  onClickEventHandler,
  onKeyDownEventHandler,
  onMouseDownEventHandler
} from '../../../util/eventHandlers';

export interface DropdownAtomProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  state?: InputState;
  onClick?: (e: React.MouseEvent<HTMLSelectElement, MouseEvent>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLSelectElement>) => void;
  onMouseDown?: (e: React.MouseEvent<HTMLSelectElement, MouseEvent>) => void;
}

const SelectVariants = cva(
  [
    'preflight',
    'ds-form-select',
    'ds-h-[40px]',
    'ds-rounded',
    'ds-p-2',
    '!ds-border',
    '!ds-font-sans',
    'ds-container',
    'ds-bg-[center_right_0.25rem]'
  ],
  commonVariants
);
interface SelectVariants extends VariantProps<typeof SelectVariants> {}
const input = (variants: SelectVariants) => SelectVariants(variants);
const arrowImage = `url('data:image/svg+xml,<svg width="16" height="16" viewBox="5 -5 15 35" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="%23949494" ><path d="M21.375 8.09253L12.4417 17.025C12.3837 17.0831 12.3148 17.1291 12.2391 17.1605C12.1632 17.192 12.082 17.2082 12 17.2082C11.918 17.2082 11.8368 17.192 11.7609 17.1605C11.6852 17.1291 11.6163 17.0831 11.5583 17.025L2.625 8.09253" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="%23000000" /></svg>')`;

const DropdownAtom = forwardRef(
  (
    {
      state = 'default' as InputState,
      disabled = false,
      className = '',
      ...props
    }: DropdownAtomProps,
    ref: React.Ref<HTMLSelectElement>
  ) => {
    // Extract specific event handlers from props
    const { onClick, onKeyDown, onMouseDown, ...restProps } = props;

    return (
      <select
        ref={ref}
        aria-disabled={disabled}
        style={{ backgroundImage: arrowImage }}
        className={twMerge(input({ disabled, state }), className)}
        onClick={(e) => onClickEventHandler(e, disabled, onClick ?? (() => {}))}
        onKeyDown={(e) => onKeyDownEventHandler(e, disabled, onKeyDown ?? (() => {}))}
        onMouseDown={(e) =>
          onMouseDownEventHandler(e, disabled, onMouseDown ?? (() => {}))
        }
        {...restProps}
      >
        {props.children}
      </select>
    );
  }
);

export default DropdownAtom;
